import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NoAlerts } from '../NoAlerts/NoAlerts';
import { WarningsSBlock } from './WarningsSBlock';
import { getWarningsNumber } from '../../../../utils/utils';
import { useInventorySubscription } from '../useInventorySubscription';
const useStyles = makeStyles(() => ({
    contentContainer: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100% - 41px)',
    },
}));
export const InventoryWidgetS = () => {
    const inventory = useInventorySubscription();
    const deliveryDelay = inventory ? inventory.some((ingredient) => ingredient.deliveryDelay) : false;
    const { criticalCount, earlyCount } = getWarningsNumber(inventory);
    const isEmpty = !criticalCount && !earlyCount;
    const classes = useStyles();
    return (React.createElement("div", { className: classes.contentContainer }, isEmpty ? (React.createElement(NoAlerts, null)) : (React.createElement(WarningsSBlock, { criticalCount: criticalCount, earlyCount: earlyCount, deliveryDelay: deliveryDelay }))));
};
//# sourceMappingURL=InventoryWidgetS.js.map